/**
 * Created by mqamhieh on 11/21/16.
 */
window.ScreeningAnswerForm = function(scope, screeningForm, applicationId, jobId, formType, bulk, userId) {
    var form = this;
    var formName = "screening-form";
    var _protected = BaseForm.call(form, formName, scope);

    form.questions = screeningForm.questions;
    form.applicationId = applicationId;
    form.questionsFormId = screeningForm.id;
    form.jobId = jobId;
    form.formType = formType;
    form.countries = window.countries;
    form.textForAll = false;
    form.hasVideo = false;

    const SCREENING_QUESTION_TYPES = {
        TEXT: 'TEXT',
        TEXT_VIDEO: 'TEXT_VIDEO',
        MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
        SINGLE_CHOICE: 'SINGLE_CHOICE',
        YES_NO: 'YES_NO',
        COUNTRIES: 'COUNTRIES'
    };

    if (bulk){
        form.bulk = bulk;
        form.appliedJobIds = screeningForm.applied_job_ids;
        form.userId = userId;
    }

    var textAnswerTemp = '';

    for (var i in form.questions) {

        form.questions[i].answers = form.questions[i].answers || [];
        var answers = form.questions[i].answers;

        form.questions[i].options = form.questions[i].options || [];

        if (form.questions[i].type === SCREENING_QUESTION_TYPES.TEXT_VIDEO) {
            form.hasVideo = true;
        }

        if ($(window).width() >= 992) {

            // In screens were options appear side by side, sort them by column
            // Original Sorting (normal): [0, 1, 2, 3, 4, 5, ... etc.]
            // Desired Output: [0, 3, 1, 4, 2, 5, ... etc.]
            // Formula For Output: [0, 3+0, 1, 3+1, 2, 3+2, ... etc.] Where 3 = breakPoint = middle of array
            var sortedOptions = [];
            var iterator = 0;
            var totalOptionsCount = form.questions[i].options.length
            var breakPoint = Math.ceil(totalOptionsCount / 2);

            for (var j = 0; j < totalOptionsCount; j++) {
                var targetIndex = iterator;

                if (j % 2 === 1) {
                    targetIndex += breakPoint;
                    iterator++;
                }

                var option = form.questions[i].options[targetIndex];
                option.content = option.content || "";

                if (option.content.length >= 50) {
                    form.questions[i].long_options = true;
                }

                sortedOptions.push(form.questions[i].options[targetIndex]);
            }

            if (!form.questions[i].long_options) {
                form.questions[i].options = sortedOptions;
            }
        }

        if (answers[0]) {
            if (!answers[0]['original_file_href']) {
                form.questions[i].answer_with_text = !!answers[0].answer;
            }

            if (answers[0].options && answers[0].options.length > 0) {
                form.questions[i].temp_answers = {};

                if (form.questions[i].type === SCREENING_QUESTION_TYPES.MULTIPLE_CHOICE) {
                    answers[0].options.forEach(function (option) {
                        form.questions[i].temp_answers[option.id] = true;
                    });

                } else if (form.questions[i].type === SCREENING_QUESTION_TYPES.SINGLE_CHOICE || form.questions[i].type === SCREENING_QUESTION_TYPES.YES_NO) {
                    form.questions[i].temp_answers[0] = answers[0].options[0].id;
                }
            }
        }
    }

    form.onVideoPublished = function (video, index) {
        form.validator.clearValidate(index);
        scope.$digest();
    };

    form.onAnswerWithTextCheck = function (value, index) {
        var question = form.questions[index];

        if (question.answers && question.answers[0]) {
            if (!value) {
                textAnswerTemp = question.answers[0].answer;
                question.answers[0].answer = "";
            }
            else {
                question.answers[0].answer = textAnswerTemp;
                textAnswerTemp = "";
                form.validator.clearValidate(index);
            }
        }

    };

    form.onRemoveJob = function () {
        console.warn("Override this function");
    };

    form.setJobsName = function (jobsName) {
        form.applied_job_names = jobsName;
    };

    form.setSavedData = function () {
        for (var i = 0; i < form.questions.length; i++) {
            if (form.questions[i].type === SCREENING_QUESTION_TYPES.MULTIPLE_CHOICE) {

                if (form.questions[i].answers[0]) {
                    form.questions[i].answers[0].options = [];
                }

                form.questions[i].answers = [{options: []}];
                for (var answer in form.questions[i].temp_answers) {
                    if (form.questions[i].temp_answers[answer]) {
                        form.questions[i].answers[0].options.push(parseInt(answer));
                    }
                }

                if (!form.questions[i].answers[0].options.length) {
                    form.questions[i].answers = [];
                }

            }
            else if (form.questions[i].type === SCREENING_QUESTION_TYPES.SINGLE_CHOICE || form.questions[i].type === SCREENING_QUESTION_TYPES.YES_NO) {
                if (form.questions[i].temp_answers && form.questions[i].temp_answers[0]) {
                    form.questions[i].answers = [{options: []}];
                    form.questions[i].answers[0].options.push(form.questions[i].temp_answers[0]);
                }
            }
            else if (form.questions[i].type === SCREENING_QUESTION_TYPES.COUNTRIES) {
                if (form.questions[i].answer_text) {
                    form.questions[i].answers = form.questions[i].answers || [];
                    form.questions[i].answers[0] = {answer: form.questions[i].answer_text};
                }
            } else if (form.questions[i].type === SCREENING_QUESTION_TYPES.TEXT_VIDEO && form.questions[i].answers?.[0]?.['original_file']) {
                form.questions[i].answers[0]['media_uuid'] = 1;
            }

            for (var j = 0; j < form.questions[i].answers.length; j++) {
                if (form.questions[i].answers[j].options && typeof form.questions[i].answers[j].options[0] === "object") {
                    delete form.questions[i].answers[j].options;
                }
            }
        }
    };

    form.getCleanedQuestions = function () {
        var cleanedQuestions = [];
        for (var i = 0; i < form.questions.length; i++) {
            if (form.questions[i].answers.length !== 0) {
                cleanedQuestions.push(form.questions[i]);
            }
        }
        return cleanedQuestions;
    };

    form.getPreparedData = function () {
        form.setSavedData();
        return {"id":form.questionsFormId,"questions":form.getCleanedQuestions()};
    };

    form.save = function () {

        form.setSavedData();
        return JobApplicationAPI.answerScreeningQuestions(form.jobId, form.applicationId, form.questionsFormId, form.questions, form.formType);
    };
};